export default [
  { id: "#rect1", x: "126", y: "172.9", width: "185.8", height: "55.7" },

  { id: "#rect2", x: "245.8", y: "287.7", width: "65.7", height: "335" },

  { id: "#rect3", x: "500", y: "174.1", width: "67", height: "733" },

  { id: "#rect4", x: "622", y: "173.9", width: "67", height: "732.7" },

  { id: "#rect5", x: "246.3", y: "683.7", width: "65.7", height: "223.4" },

  { id: "#rect6", x: "128", y: "795.7", width: "65", height: "111.4" },

  { id: "#rect7", x: "128", y: "851.7", width: "184", height: "55.4" },

  { id: "#rect8", x: "375.3", y: "173.7", width: "65.7", height: "733.4" },

  { id: "#rect9", x: "128.3", y: "683.7", width: "183.7", height: "56" },

  { id: "#rect10", x: "500", y: "851.2", width: "189", height: "55.4" },

  { id: "#rect11", x: "704", y: "513.3", width: "275", height: "55" },

  { id: "#rect12", x: "126", y: "173.7", width: "67", height: "566" },

  { id: "#rect13", x: "245.8", y: "400.7", width: "195.2", height: "55" },

  { id: "#rect14", x: "500", y: "173.7", width: "189", height: "55" },

  { id: "#rect15", x: "864", y: "174.3", width: "67", height: "732.4" },

  { id: "#rect16", x: "752", y: "174.3", width: "67", height: "732.4" }
];
